import React, { Component } from "react";
import ReactDOM from "react-dom";
import { ActionIDs } from "../../../GenericWebController/ActionGraph/ActionIDs/ActionIDs";
import {
  DebugAlert,
  Class,
  Interface,
  Abstract,
  ObjectTypes,
  JSTypeOperator,
  cListForBase,
} from "../../../GenericCoreGraph/ClassFramework/Class";
import TObject from "../../TObject";
import Actions from "../../../GenericWebController/ActionGraph/Actions";
import GenericWebGraph from "../../../GenericWebController/GenericWebGraph";
import { CommandInterfaces } from "../../../GenericWebController/CommandInterpreter/cCommandInterpreter";
import { CommandIDs } from "../../../GenericWebController/CommandInterpreter/CommandIDs/CommandIDs";

import { withStyles } from "@material-ui/core/styles";
import BigCalendarStyles from "../../../../ScriptStyles/BigCalendarStyles";
import classNames from "classnames";
import moment from "moment";

import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";

import Button from "@material-ui/core/Button";

import CardHeader from "@material-ui/core/CardHeader";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import DialogActions from "@material-ui/core/DialogActions";

import IconButton from "@material-ui/core/IconButton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIos from "@material-ui/icons/ArrowForwardIos";
import Close from "@material-ui/icons/Close";
import TBigCalenderItem from "./TBigCalenderItem";
import TBigCalenderTimeHeader from "./TBigCalenderTimeHeader";
import TBigCalenderDayHeader from "./TBigCalenderDayHeader";

import Typography from "@material-ui/core/Typography";
import { Tooltip } from "@material-ui/core";

var TBigCalender = Class(
  TObject,
  CommandInterfaces.IBigCalenderRefreshCommandReceiver,

  {
    ObjectType: ObjectTypes.Get("TBigCalender"),
    constructor: function (_Props) {
      TBigCalender.BaseObject.constructor.call(this, _Props);
      this.state = {
        ...this.state,
        loaded: false,
        contentHeight:
          GenericWebGraph.MainContainerSize.Height - this.props.heighcalibrator,
        addWeek: 0,
        ReservationCount: "",
        mobileSize: GenericWebGraph.MainContainerSize.Width < 600,
      };
      this.ItemList = [];
      if (
        this.props.selectedreservationlist &&
        this.props.selectedreservationlist != null &&
        JSTypeOperator.IsArray(this.props.selectedreservationlist)
      ) {
        this.ReservationLessonList = this.props.selectedreservationlist;
        this.HandleSelectedReservationCountWriter(this); 
      } else {
        this.ReservationLessonList = [];
      }
      this.containerRef = React.createRef();
    },
    Receive_BigCalenderRefreshCommand: function (_Data) {
      this.HandleRefresh();
    },
    Destroy: function () {
      TBigCalender.BaseObject.Destroy.call(this);
    },
    HandleRefreshReservationList: function () {
      //

      var __This = this;
      var __CellList = this.HandleGetCellListByCellState(
        window.Enums.EBigCalenderCellState.SelectedFromCustomer
      );

      var __ReservationLessonList = [];
      var __MergedCellCount = this.props.mergedcell;

      for (var i = 0; i < __CellList.length; i++) {
        var __NextCount = this.HandleGetNextSelectedCount(__CellList[i]);
        var __IsMain =
          __NextCount / __MergedCellCount ==
          Math.ceil(__NextCount / __MergedCellCount);
        if (__IsMain) {
          var __ReservationTimes = [];
          __ReservationTimes.push(__CellList[i]);

          var __OtherTimes = this.HandleGetCellLaterByCount(
            __CellList[i],
            __MergedCellCount - 1
          );
          for (var j = 0; j < __OtherTimes.length; j++) {
            __ReservationTimes.push(__OtherTimes[j]);
          }
          var firstReservationItem = __ReservationTimes[0];
          var secondReservationItem = __ReservationTimes[0];
          if (__ReservationTimes.length > 1) {
            secondReservationItem = __ReservationTimes[1];
          }
          var __Date =
            firstReservationItem.props.blockstarthour +
            ":" +
            (firstReservationItem.props.blockstartminute === 0
              ? firstReservationItem.props.blockstartminute + "0"
              : firstReservationItem.props.blockstartminute) +
            " - " +
            secondReservationItem.props.blockendhour +
            ":" +
            (secondReservationItem.props.blockendminute === 0
              ? secondReservationItem.props.blockendminute + "0"
              : secondReservationItem.props.blockendminute);

          __ReservationLessonList.push({
            DayDate: __CellList[i].props.daydate,
            StartBlockKey: __CellList[i].props.mykey,
            ReservationTimes: __ReservationTimes,
            DayStr: __Date,
          });
        }
      }

      let __ReservationLessonListLength = __ReservationLessonList.length;
      console.log(__ReservationLessonListLength);
      console.log(__This.props.selectedLessonPlan);

      for (let k = 0; k < __ReservationLessonListLength; k++) {
        for (let j = 1; j < __This.props.selectedLessonPlan; j++) {
          let date = new Date(__ReservationLessonList[k].DayDate);
          date.setDate(date.getDate() + 7 * j);

          __ReservationLessonList.push({
            DayDate: date,
            StartBlockKey: __ReservationLessonList[k].StartBlockKey,
            ReservationTimes: __ReservationLessonList[k].ReservationTimes,
            DayStr: __ReservationLessonList[k].DayStr,
          });
        }
      }
      console.log(__CellList);
      console.log(__ReservationLessonList);
      this.ReservationLessonList = __ReservationLessonList;

      this.HandleSelectedReservationCountWriter(this);

      if (
        this.props.customerselectiononchange &&
        JSTypeOperator.IsFunction(this.props.customerselectiononchange)
      ) {
        this.props.customerselectiononchange(this.ReservationLessonList);
      }
    },
    HandleSelectedReservationCountWriter:function (__This) {
      setTimeout(function () {
        __This.setState({
          ReservationCount:
            __This.state.Language.YourReservationCount +
            " " +
            __This.ReservationLessonList.length /
              __This.props.selectedLessonPlan +
            " / " +
            (
              __This.props.mustselectcell /
              __This.props.selectedLessonPlan /
              __This.props.mergedcell
            ).toString(),
        });
      });
    },
    HandleScrollToCell: function (_CellKey) {
      if (_CellKey && _CellKey != null) {
        var __Item = this.HandleGetItemByKey(_CellKey);
        __Item = ReactDOM.findDOMNode(__Item.Instance);

        //__Item.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
        __Item.scrollIntoView({ block: "start" });

        /*var myElement = document.getElementById('element_within_div');
        var topPos = myElement.offsetTop;
        The variable topPos is now set to the distance between the top of the scrolling div and the element you wish to have visible(in pixels).

        Now we tell the div to scroll to that position using scrollTop:

        document.getElementById('scrolling_div').scrollTop = topPos;*/
      }
    },
    HandleScrollToNineTimesForSeller: function () {
      var __WeekStartDate = this.HandleGetStartDate();
      var __Date = new Date(__WeekStartDate);

      __Date.setDate(__WeekStartDate.getDate() + this.state.addWeek * 7);

      var __NextDate = new Date(__Date);
      __NextDate.setDate(__NextDate.getDate() + 6);

      //TODO Error: Unable to find node on an unmounted component.
      var __Item = ReactDOM.findDOMNode(this.ItemList[133].Instance);
      var __ContainerItem = ReactDOM.findDOMNode(this.containerRef.current);

      var __OffsetParrentItem = __Item.offsetParent;

      try {
        var __ScrollableHeight =
          __ContainerItem.scrollHeight - __ContainerItem.clientHeight;

        var __RealOffsetTop =
          __Item.offsetTop -
          (__OffsetParrentItem.offsetHeight - __ContainerItem.offsetHeight);

        var __Percentage = (__RealOffsetTop / __ScrollableHeight) * 100;

        __ContainerItem.scrollTop = (__ScrollableHeight / 100) * __Percentage;
      } catch {}
    },

    HandleScrollToFirst: function () {
      var __WeekStartDate = this.HandleGetStartDate();
      var __Date = new Date(__WeekStartDate);

      __Date.setDate(__WeekStartDate.getDate() + this.state.addWeek * 7);

      var __NextDate = new Date(__Date);
      __NextDate.setDate(__NextDate.getDate() + 6);

      var __StartDate = new Date(
        __Date.getYear() + 1900,
        __Date.getMonth(),
        __Date.getDate(),
        0,
        0,
        0,
        0
      );
      var __EndDate = new Date(
        __NextDate.getYear() + 1900,
        __NextDate.getMonth(),
        __NextDate.getDate(),
        23,
        59,
        59,
        999
      );

      var __StartTime = __StartDate.getTime();
      var __EndTime = __EndDate.getTime();

      for (var i = 0; i < this.ItemList.length; i++) {
        if (
          __StartTime <= this.ItemList[i].Instance.props.daydate.getTime() &&
          this.ItemList[i].Instance.props.daydate.getTime() <= __EndTime &&
          this.ItemList[i].Instance.state.cellstate !=
            window.Enums.EBigCalenderCellState.NotSelected
        ) {
          //TODO Error: Unable to find node on an unmounted component.
          var __Item = ReactDOM.findDOMNode(this.ItemList[i].Instance);
          var __ContainerItem = ReactDOM.findDOMNode(this.containerRef.current);

          var __OffsetParrentItem = __Item.offsetParent;

          try {
            var __ScrollableHeight =
              __ContainerItem.scrollHeight - __ContainerItem.clientHeight;

            var __RealOffsetTop =
              __Item.offsetTop -
              (__OffsetParrentItem.offsetHeight - __ContainerItem.offsetHeight);

            var __Percentage = (__RealOffsetTop / __ScrollableHeight) * 100;

            __ContainerItem.scrollTop =
              (__ScrollableHeight / 100) * __Percentage;
            break;
          } catch {}
        }
      }
    },
    HandleCalenderLoaded: function () {
      var __This = this;
      __This.setState(
        {
          loaded: true,
        },
        () => {
          if (__This.props.scrolltofirst) {
            if (
              __This.props.type ===
              window.Enums.EBigCalenderType.AvailableTimeSelection
            ) {
              __This.HandleScrollToNineTimesForSeller();
            } else {
              __This.HandleScrollToFirst();
            }
          }
        }
      );
    },

    //////////////////////////////////////////////////////////////////
    /////////////////  AsycnLoads ////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    HandleRefresh: function () {
      var __This = this;

      setTimeout(() => {
        __This.AsyncLoad();
      }, 10);
    },
    AsyncLoad: function () {
      TBigCalender.BaseObject.AsyncLoad.call(this);

      var __This = this;
      for (var i = 0; i < this.ItemList.length; i++) {
        this.ItemList[i].Instance.HandleClear();
      }

      var __WeekStartDate = __This.HandleGetStartDate();
      __WeekStartDate.setDate(
        __WeekStartDate.getDate() + __This.state.addWeek * 7
      );

      if (
        __This.props.type ==
        window.Enums.EBigCalenderType.AvailableTimeSelection
      ) {
        this.HandleAsyncLoad_AvailableTimeSelection(__WeekStartDate);
      } else if (
        __This.props.type == window.Enums.EBigCalenderType.MiniAvailableTimeShow
      ) {
        this.HandleAsyncLoad_MiniAvailableTimeShow(__WeekStartDate);
      } else if (
        __This.props.type ==
          window.Enums.EBigCalenderType
            .CustomerAvailableBookSelection_Individual ||
        __This.props.type ==
          window.Enums.EBigCalenderType.CustomerAvailableBookSelection_Class
      ) {
        this.HandleAsyncLoad_CustomerAvailableBookSelection(__WeekStartDate);
      } else if (
        __This.props.type == window.Enums.EBigCalenderType.SellerBookedScheduler
      ) {
        this.HandleAsyncLoad_SellerBookedScheduler(__WeekStartDate);
      } else if (
        __This.props.type ==
        window.Enums.EBigCalenderType.CustomerBookedScheduler
      ) {
        this.HandleAsyncLoad_CustomerBookedScheduler(__WeekStartDate);
      } else if (JSTypeOperator.IsFunction(this.props.asyncload)) {
        this.props.asyncload(this, __WeekStartDate);
      }
    },
    HandleAsyncLoad_CustomerBookedScheduler: function (_WeekStartDate) {
      var __This = this;

      if (_WeekStartDate) {
        Actions.GetCustomerBookedTimeForCustomer(
          _WeekStartDate,
          function (_Message) {
            CommandIDs.ResultListCommand.RunIfHas(_Message, function (_Data) {
              _Data.ResultList.map(function (_Item, _Index) {
                var __Date = new Date(_WeekStartDate);

                var __DayNumber = GenericWebGraph.GetDayIDByDate(__Date);

                var __BaseNumber = 7 - __DayNumber;

                __Date.setDate(
                  __Date.getDate() + ((__BaseNumber + _Item.Day) % 7)
                );
                var __Key = __This.HandleGetKeyForBlockByTime(
                  __Date,
                  _Item.StartHour,
                  _Item.StartMinute,
                  _Item.EndHour,
                  _Item.EndMinute
                );

                __This.HandleSetCellItemFormKey(__Key, _Item);
              });

              __This.HandleCalenderLoaded();
            });
          }
        );
      }
    },
    HandleAsyncLoad_SellerBookedScheduler: function (_WeekStartDate) {
      var __This = this;

      if (_WeekStartDate) {
        Actions.GetSellerBookedTimeForSeller(
          _WeekStartDate,
          function (_Message) {
            CommandIDs.ResultListCommand.RunIfHas(_Message, function (_Data) {
              _Data.ResultList.map(function (_Item, _Index) {
                var __Date = new Date(_WeekStartDate);

                var __DayNumber = GenericWebGraph.GetDayIDByDate(__Date);

                var __BaseNumber = 7 - __DayNumber;

                __Date.setDate(
                  __Date.getDate() + ((__BaseNumber + _Item.Day) % 7)
                );
                var __Key = __This.HandleGetKeyForBlockByTime(
                  __Date,
                  _Item.StartHour,
                  _Item.StartMinute,
                  _Item.EndHour,
                  _Item.EndMinute
                );

                __This.HandleSetCellItemFormKey(__Key, _Item);
              });

              __This.HandleCalenderLoaded();
            });
          }
        );
      }
    },
    HandleAsyncLoad_MiniAvailableTimeShow: function (_WeekStartDate) {
      var __This = this;

      if (__This.props.sellerDetailId && _WeekStartDate) {
        Actions.GetSellerAvailableTimeForCustomer(
          __This.props.sellerDetailId,
          __This.props.lessonId,
          _WeekStartDate,
          function (_Message) {
            CommandIDs.ResultListCommand.RunIfHas(_Message, function (_Data) {
              _Data.ResultList.map(function (_Item, _Index) {
                var __Date = new Date(_WeekStartDate);

                var __DayNumber = GenericWebGraph.GetDayIDByDate(__Date);

                var __BaseNumber = 7 - __DayNumber;

                __Date.setDate(
                  __Date.getDate() + ((__BaseNumber + _Item.Day) % 7)
                );
                var __Key = __This.HandleGetKeyForBlockByTime(
                  __Date,
                  _Item.StartHour,
                  _Item.StartMinute,
                  _Item.EndHour,
                  _Item.EndMinute
                );

                __This.HandleSetCellItemFormKey(__Key, _Item);
              });

              __This.HandleCalenderLoaded();
            });
          }
        );
      }
    },
    HandleAsyncLoad_CustomerAvailableBookSelection: function (_WeekStartDate) {
      var __This = this;

      if (__This.props.sellerDetailId && _WeekStartDate) {
        Actions.GetSellerAvailableTimeForCustomer(
          __This.props.sellerDetailId,
          __This.props.lessonId,
          _WeekStartDate,
          function (_Message) {
            CommandIDs.ResultListCommand.RunIfHas(_Message, function (_Data) {
              _Data.ResultList.map(function (_Item, _Index) {
                var __Date = new Date(_WeekStartDate);

                var __DayNumber = GenericWebGraph.GetDayIDByDate(__Date);

                var __BaseNumber = 7 - __DayNumber;

                __Date.setDate(
                  __Date.getDate() + ((__BaseNumber + _Item.Day) % 7)
                );
                var __Key = __This.HandleGetKeyForBlockByTime(
                  __Date,
                  _Item.StartHour,
                  _Item.StartMinute,
                  _Item.EndHour,
                  _Item.EndMinute
                );

                __This.HandleSetCellItemFormKey(__Key, _Item);
              });

              if (__This.ReservationLessonList.length > 0) {
                __This.ReservationLessonList.map(function (
                  _ReservedItem,
                  _Index
                ) {
                  var __StartDate = new Date(_WeekStartDate);
                  var __EndDate = new Date(_WeekStartDate);
                  __EndDate.setDate(__EndDate.getDate() + 6);

                  if (
                    __StartDate <= _ReservedItem.DayDate &&
                    __EndDate >= _ReservedItem.DayDate
                  ) {
                    for (
                      var i = 0;
                      i < _ReservedItem.ReservationTimes.length;
                      i++
                    ) {
                      var __Item = __This.HandleGetItemByKey(
                        _ReservedItem.ReservationTimes[i].props.mykey
                      );
                      __Item.Instance.HandleSetCellStateDirect_Unsafe(
                        window.Enums.EBigCalenderCellState.SelectedFromCustomer
                      );
                    }
                  }
                });

                if (
                  __This.props.customerselectiononchange &&
                  JSTypeOperator.IsFunction(
                    __This.props.customerselectiononchange
                  )
                ) {
                  __This.props.customerselectiononchange(
                    __This.ReservationLessonList
                  );
                }
              }

              __This.HandleCalenderLoaded();
            });
          }
        );
      }
    },
    HandleAsyncLoad_AvailableTimeSelection: function (_WeekStartDate) {
      var __This = this;

      if (_WeekStartDate) {
        Actions.GetSellerAvailableTime(function (_Message) {
          CommandIDs.ResultListCommand.RunIfHas(_Message, function (_Data) {
            _Data.ResultList.map(function (_Item, _Index) {
              var __Date = new Date(_WeekStartDate);

              __Date.setDate(__Date.getDate() + _Item.Day);
              var __Key = __This.HandleGetKey(
                __Date,
                _Item.StartHour,
                _Item.StartMinute,
                _Item.EndHour,
                _Item.EndMinute
              );

              __This.HandleSetCellItemFormKey(__Key, _Item);
            });

            __This.HandleCalenderLoaded();
          });
        });
      }
    },
    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    HandleSetCellItemFormKey: function (_Key, _Item) {
      var __Item = this.HandleGetItemByKey(_Key);
      __Item.Instance.HandleSetTimeItem(_Item);
    },
    HandleSave: function () {
      if (
        this.props.type == window.Enums.EBigCalenderType.AvailableTimeSelection
      ) {
        this.HandleSaveForAvailableTime();
      } else if (JSTypeOperator.IsFunction(this.props.handlesave)) {
        this.props.handlesave(this);
      }
    },
    HandleSaveForAvailableTime: function () {
      var __This = this;
      var __List = this.HandleGetSelectedList();
      if (__List.length > 0) {
        this.setState({
          loaded: false,
        });
        Actions.SetSellerAvailableTime(__List, function (_Message) {
          CommandIDs.ResultListCommand.RunIfHas(_Message, function (_Data) {
            _Data.ResultList.map(function (_Item, _Index) {
              var __Date = __This.HandleGetStartDate();
              __Date.setDate(__Date.getDate() + _Item.Day);
              var __Key = __This.HandleGetKey(
                __Date,
                _Item.StartHour,
                _Item.StartMinute,
                _Item.EndHour,
                _Item.EndMinute
              );
              __This.HandleSetCellItemFormKey(__Key, _Item);
            });

            __This.props.owner.HandleClose();
          });

          __This.setState({
            loaded: true,
          });
        });
      } else {
        window.App.MessageBox.ShowMessage(
          this.state.Language.Warning,
          this.state.Language.PleaseSelectAvailableTimes,
          "danger",
          true
        );
      }
    },
    HandleGetSelectedList: function () {
      ///var __Result = [];
      /*for (var i = 0; i < this.ItemList.length; i++)
      {
        if (this.ItemList[i].Instance.HandleIsStateThat(window.Enums.EBigCalenderCellState.SelectedFromSeller))
        {
          __Result.push(this.ItemList[i].Instance.HandleGetSelectedItemObject());
        }
      }*/

      var __List = this.HandleGetCellItemObjectListByCellState(
        window.Enums.EBigCalenderCellState.SelectedFromSeller
      );
      var __List2 = this.HandleGetCellItemObjectListByCellState(
        window.Enums.EBigCalenderCellState.BookedByOther
      );
      var __List3 = this.HandleGetCellItemObjectListByCellState(
        window.Enums.EBigCalenderCellState.BookedGroupByYou
      );

      var __Result = [...__List, ...__List2, ...__List3];

      return __Result;
    },
    HandleGetCellItemObjectListByCellState: function (_CellState) {
      var __Result = [];
      for (var i = 0; i < this.ItemList.length; i++) {
        if (this.ItemList[i].Instance.HandleIsStateThat(_CellState)) {
          __Result.push(
            this.ItemList[i].Instance.HandleGetSelectedItemObject(_CellState)
          );
        }
      }
      return __Result;
    },
    HandleGetCellListByCellState: function (_CellState) {
      var __Result = [];
      for (var i = 0; i < this.ItemList.length; i++) {
        if (this.ItemList[i].Instance.HandleIsStateThat(_CellState)) {
          __Result.push(this.ItemList[i].Instance);
        }
      }
      return __Result;
    },
    HandleLoadWeek: function (_Next) {
      var __This = this;
      if (_Next) {
        var __CurrentWeek = this.state.addWeek;
        this.setState(
          {
            addWeek: __CurrentWeek + 1,
            loaded: false,
          },
          () => {
            __This.AsyncLoad();
          }
        );
      } else {
        var __CurrentWeek = this.state.addWeek;
        if (__CurrentWeek > 0) {
          this.setState(
            {
              addWeek: __CurrentWeek > 0 ? __CurrentWeek - 1 : 0,
              loaded: false,
            },
            () => {
              __This.AsyncLoad();
            }
          );
        }
      }
    },
    HandleSetCellStateFromKey: function (_CellKey, _CellState) {
      var __Item = this.HandleGetItemByKey(_CellKey);

      var __Right = __Item.Instance.props.right;
      var __Bottom = __Item.Instance.props.bottom;
      var __Date = __Item.Instance.props.daydate;
      var __BlockStartHour = __Item.Instance.props.blockstarthour;
      var __BlockStartMinute = __Item.Instance.props.blockstartminute;
      var __BlockEndHour = __Item.Instance.props.blockendhour;
      var __BlockEndMinute = __Item.Instance.props.blockendminute;
      var __MergedCell = __Item.Instance.props.mergedcell;
      var __StepMinute = __Item.Instance.props.stepminute;
      this.HandleGetBigCalenderItem(
        _CellKey,
        __Right,
        __Bottom,
        __Date,
        __BlockStartHour,
        __BlockStartMinute,
        __BlockEndHour,
        __BlockEndMinute,
        _CellState,
        true,
        __MergedCell,
        __StepMinute
      );
    },
    HandleGetItemByKey: function (_Key) {
      var __ResultItem = this.ItemList.find(function (_Item) {
        return _Item.ReactItem.key == _Key;
      });
      return __ResultItem;
    },
    HandleGetKey(
      _Date,
      _BlockStartHour,
      _BlockStartMinute,
      _BlockEndHour,
      _BlockEndMinute
    ) {
      var __Key =
        _Date.getYear() +
        "_" +
        _Date.getMonth() +
        "_" +
        _Date.getDate() +
        "_" +
        _BlockStartHour +
        "_" +
        _BlockStartMinute +
        "_" +
        _BlockEndHour +
        "_" +
        _BlockEndMinute;
      return __Key;
    },
    HandleGetKeyForBlockByTime(_Date, _BlockHour, _BlockMinute) {
      var __StartHour = this.props.starthour;
      var __EndHour = this.props.endhour;

      var __StepMinute = this.props.stepminute;

      var __StartMinute = this.props.startminute;
      var __EndMinute = this.props.endminute;

      var __StartIndex = __StartHour * 60 + __StartMinute;
      var __EndIndex = __EndHour * 60 + __EndMinute;

      var __FindIndex = _BlockHour * 60 + _BlockMinute;

      var __Block = Math.floor((__FindIndex - __StartIndex) / __StepMinute);

      var __FinalStartHour = Math.floor(
        (__Block * __StepMinute + __StartIndex) / 60
      );
      var __FinalStartMinute = Math.floor(
        (__Block * __StepMinute + __StartIndex) % 60
      );

      var __FinalEndHour = Math.floor(
        ((__Block + 1) * __StepMinute + __StartIndex) / 60
      );
      var __FinalEndMinute = Math.floor(
        ((__Block + 1) * __StepMinute + __StartIndex) % 60
      );

      return this.HandleGetKey(
        _Date,
        __FinalStartHour,
        __FinalStartMinute,
        __FinalEndHour,
        __FinalEndMinute
      );
    },
    HandleGetStartDate: function () {
      var __ResultDate = new Date();
      if (
        this.props.type ==
          window.Enums.EBigCalenderType.AvailableTimeSelection ||
        this.props.type == window.Enums.EBigCalenderType.ClassTimeSelection
      ) {
        __ResultDate = new Date(2020, 0, 6, 1, 0, 0, 0); ////new Date(moment("01 06 2020"));
      } else if (this.props.weekstartdate) {
        __ResultDate = new Date(this.props.weekstartdate);
      } else if (window.App.ServerDate != null) {
        __ResultDate = new Date(window.App.ServerDate);
      }

      var __ReservationBeforeDay =
        this.props.type ==
          window.Enums.EBigCalenderType.AvailableTimeSelection ||
        this.props.type == window.Enums.EBigCalenderType.ClassTimeSelection ||
        this.props.type ==
          window.Enums.EBigCalenderType.SellerBookedScheduler ||
        this.props.type == window.Enums.EBigCalenderType.CustomerBookedScheduler
          ? 0
          : this.props.reservationbeforeday
          ? this.props.reservationbeforeday
          : window.App.GlobalParams.CanReservationBeforeDay;

      if (__ResultDate.getHours() > 20 && __ReservationBeforeDay > 0) {
        __ReservationBeforeDay++;
      }

      __ResultDate.setDate(__ResultDate.getDate() + __ReservationBeforeDay);
      return __ResultDate;
    },
    HandleOnResizeMain: function (_Size) {
      var __This = this;

      this.setState({
        contentHeight: _Size.Height - __This.props.heighcalibrator,
      });
      if (_Size.Width < 600) {
        __This.setState({ mobileSize: true });
      } else {
        __This.setState({ mobileSize: false });
      }
    },
    HandleGetCellBeforeAndLater: function (_CellInstance) {
      var __Result = [];
      var __Index = this.HandleGetCellIndex(_CellInstance);

      if (this.ItemList.length > __Index + 7) {
        __Result.push(this.ItemList[__Index + 7].Instance);
      }
      if (-1 < __Index - 7) {
        __Result.push(this.ItemList[__Index - 7].Instance);
      }
      return __Result;
    },
    HandleGetCellLater: function (_CellInstance) {
      var __Result = null;
      var __Index = this.HandleGetCellIndex(_CellInstance);

      if (this.ItemList.length > __Index + 7) {
        __Result = this.ItemList[__Index + 7].Instance;
      }
      return __Result;
    },

    HandleGetCellBefore: function (_CellInstance) {
      var __Result = null;
      var __Index = this.HandleGetCellIndex(_CellInstance);

      if (-1 < __Index - 7) {
        __Result = this.ItemList[__Index - 7].Instance;
      }

      return __Result;
    },
    HandleGetCellLaterByCount: function (
      _CellInstance,
      _Count,
      _Index = 0,
      _List = []
    ) {
      if (_Index < _Count) {
        var __Item = this.HandleGetCellLater(_CellInstance);
        _List.push(__Item);
        return this.HandleGetCellLaterByCount(
          __Item,
          _Count,
          _Index + 1,
          _List
        );
      } else {
        return _List;
      }
    },

    //////////////////////////////////////////////////////////////////
    ////////////////////////// Ders başlangıç saati tespiti //////////
    //////////////////////////////////////////////////////////////////
    HandleGetCellItemListByBooked_SellerBookedScheduler: function (_BookedID) {
      var __Result = [];
      for (var i = 0; i < this.ItemList.length; i++) {
        if (
          this.ItemList[i].Instance.HandleBookedIDIsEqual_SellerBookedScheduler(
            _BookedID
          )
        ) {
          __Result.push(this.ItemList[i].Instance);
        }
      }
      return __Result;
    },

    HandleGetLessonStartCell_SellerBookedScheduler: function (_CellInstance) {
      if (_CellInstance.AvailableTimeItemList.length > 0) {
        var __BookedList =
          this.HandleGetCellItemListByBooked_SellerBookedScheduler(
            _CellInstance.AvailableTimeItemList[0].BookedID
          );
        var __Index = 0;
        var __StartTotalMinute =
          _CellInstance.AvailableTimeItemList[0].StartTotalMinute;
        for (var i = 1; i < __BookedList.length; i++) {
          if (__BookedList[i].StartTotalMinute < __StartTotalMinute) {
            __StartTotalMinute = __BookedList[i].StartTotalMinute;
            __Index = i;
          }
        }
        return __BookedList[__Index];
      } else {
        return _CellInstance;
      }
    },
    HandleGetCellItemListByBooked_CustomerBookedScheduler: function (
      _BookedID
    ) {
      var __Result = [];
      for (var i = 0; i < this.ItemList.length; i++) {
        try {
          if (
            this.ItemList[
              i
            ].Instance.HandleBookedIDIsEqual_CustomerBookedScheduler(_BookedID)
          ) {
            __Result.push(this.ItemList[i].Instance);
          }
        } catch (_Ex) {
          var aa = 10;
        }
      }
      return __Result;
    },

    HandleGetLessonStartCell_CustomerBookedScheduler: function (_CellInstance) {
      if (_CellInstance.AvailableTimeItemList.length > 0) {
        var __BookedList =
          this.HandleGetCellItemListByBooked_CustomerBookedScheduler(
            _CellInstance.AvailableTimeItemList[0].BookedID
          );
        var __Index = 0;
        var __StartTotalMinute =
          _CellInstance.AvailableTimeItemList[0].StartTotalMinute;
        for (var i = 1; i < __BookedList.length; i++) {
          if (__BookedList[i].StartTotalMinute < __StartTotalMinute) {
            __StartTotalMinute = __BookedList[i].StartTotalMinute;
            __Index = i;
          }
        }
        return __BookedList[__Index];
      } else {
        return _CellInstance;
      }
    },
    HandleGetLessonStartCell: function (_CellInstance) {
      if (
        this.props.type == window.Enums.EBigCalenderType.SellerBookedScheduler
      ) {
        return this.HandleGetLessonStartCell_SellerBookedScheduler(
          _CellInstance
        );
      } else if (
        this.props.type == window.Enums.EBigCalenderType.CustomerBookedScheduler
      ) {
        return this.HandleGetLessonStartCell_CustomerBookedScheduler(
          _CellInstance
        );
      }
    },

    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////

    //////////////////////////////////////////////////////////////////
    ////////////////////////// Seçilebilir Kontrolleri////////////////
    //////////////////////////////////////////////////////////////////
    HandleGetCellCanSelectable_ClassTimeSelection: function (
      _CellInstance,
      _Index
    ) {
      if (
        _CellInstance.HandleIsStateThat(
          window.Enums.EBigCalenderCellState.GroupCell
        )
      ) {
        var __TwoItemList = this.HandleGetCellBeforeAndLater(_CellInstance);
        var __TrueCount = 0;
        for (var i = 0; i < __TwoItemList.length; i++) {
          if (
            __TwoItemList[i].HandleIsStateThat(
              window.Enums.EBigCalenderCellState.GroupCell
            )
          ) {
            __TrueCount++;
          }
        }
        if (__TrueCount < 2) {
          return true;
        } else {
          return false;
        }
      }
      var __List = this.HandleGetCellListByCellState(
        window.Enums.EBigCalenderCellState.GroupCell
      );
      if (__List.length < this.props.maxminute / this.props.stepminute) {
        if (__List.length % 2 == 0) {
          return true;
        } else {
          for (var i = 0; i < __List.length; i++) {
            var __OldIndex = this.HandleGetCellIndex(__List[i]);
            if (__OldIndex + 7 == _Index || __OldIndex - 7 == _Index) {
              return true;
            }
          }
          return false;
        }
      } else {
        return false;
      }
    },
    HandleGetNextSelectedCount: function (_CellInstance, _Count = 1) {
      var __CurrentCell = this.HandleGetCellLater(_CellInstance);
      if (
        __CurrentCell != null &&
        __CurrentCell.state.cellstate == _CellInstance.state.cellstate
      ) {
        return this.HandleGetNextSelectedCount(__CurrentCell, _Count + 1);
      }
      return _Count;
    },
    HandleGetBeforeSelectedCount: function (_CellInstance, _Count = 1) {
      var __CurrentCell = this.HandleGetCellBefore(_CellInstance);
      if (
        __CurrentCell != null &&
        __CurrentCell.state.cellstate == _CellInstance.state.cellstate
      ) {
        return this.HandleGetBeforeSelectedCount(__CurrentCell, _Count + 1);
      }
      return _Count;
    },
    HandleGetCellCanSelectable_CustomerAvailableBookSelection: function (
      _SelactableCellType,
      _CellInstance,
      _Index
    ) {
      var __List = this.HandleGetCellListByCellState(
        window.Enums.EBigCalenderCellState.SelectedFromCustomer
      );
      if (
        __List.length >= this.props.selectedLessonNumber * 2 &&
        _CellInstance.HandleIsStateThat(_SelactableCellType)
      ) {
        return false;
      }

      var __MergedCellCount = this.props.mergedcell;
      var __CurrentCell = _CellInstance;
      var __CanSelectable = true;
      var __ContrainedItemList = [];
      for (var i = 0; i < __MergedCellCount; i++) {
        if (
          __CurrentCell != null &&
          (__CurrentCell.HandleIsStateThat(_SelactableCellType) ||
            __CurrentCell.HandleIsStateThat(
              window.Enums.EBigCalenderCellState.SelectedFromCustomer
            )) &&
          _CellInstance.state.cellstate == __CurrentCell.state.cellstate
        ) {
          if (__CurrentCell != _CellInstance) {
            __ContrainedItemList.push(__CurrentCell);
          }
          __CurrentCell = this.HandleGetCellLater(__CurrentCell);
        } else {
          __CanSelectable = false;
          break;
        }
      }

      if (
        __CanSelectable &&
        _CellInstance.state.cellstate ==
          window.Enums.EBigCalenderCellState.SelectedFromCustomer
      ) {
        var __NextCount = this.HandleGetNextSelectedCount(_CellInstance);
        __CanSelectable =
          __NextCount / __MergedCellCount ==
          Math.ceil(__NextCount / __MergedCellCount);
      }

      if (__CanSelectable) {
        return {
          CanSelectable: true,
          ItemList: __ContrainedItemList,
        };
      } else {
        var __CurrentCell = _CellInstance;
        var __CanSelectable = true;
        __ContrainedItemList = [];
        for (var i = 0; i < __MergedCellCount; i++) {
          if (
            __CurrentCell != null &&
            (__CurrentCell.HandleIsStateThat(_SelactableCellType) ||
              __CurrentCell.HandleIsStateThat(
                window.Enums.EBigCalenderCellState.SelectedFromCustomer
              )) &&
            _CellInstance.state.cellstate == __CurrentCell.state.cellstate
          ) {
            if (__CurrentCell != _CellInstance) {
              __ContrainedItemList.push(__CurrentCell);
            }
            __CurrentCell = this.HandleGetCellBefore(__CurrentCell);
          } else {
            __CanSelectable = false;
            break;
          }
        }

        if (
          __CanSelectable &&
          _CellInstance.state.cellstate ==
            window.Enums.EBigCalenderCellState.SelectedFromCustomer
        ) {
          var __NextCount = this.HandleGetBeforeSelectedCount(_CellInstance);
          __CanSelectable =
            __NextCount / __MergedCellCount ==
            Math.ceil(__NextCount / __MergedCellCount);
        }

        if (__CanSelectable) {
          return {
            CanSelectable: true,
            ItemList: __ContrainedItemList,
          };
        } else {
          return {
            CanSelectable: false,
            ItemList: [],
          };
        }
      }
    },
    HandleGetCellCanSelectable_AvailableTimeSelection(_CellInstance, _Index) {
      if (
        _CellInstance.HandleIsStateThat(
          window.Enums.EBigCalenderCellState.NotSelected
        )
      ) {
        var __TwoItemList = this.HandleGetCellBeforeAndLater(_CellInstance);
        var __TrueCount = 0;
        for (var i = 0; i < __TwoItemList.length; i++) {
          if (
            __TwoItemList[i].HandleIsStateThat(
              window.Enums.EBigCalenderCellState.SelectedFromSeller
            )
          ) {
            __TrueCount++;
          }
        }
        if (__TrueCount > 0) {
          return {
            CanSelectable: true,
            ItemList: [],
          };
        } else {
          if (__TwoItemList.length > 0) {
            if (
              __TwoItemList[__TwoItemList.length - 1].HandleIsStateThat(
                window.Enums.EBigCalenderCellState.NotSelected
              )
            ) {
              return {
                CanSelectable: true,
                ItemList: [__TwoItemList[__TwoItemList.length - 1]],
              };
            } else if (
              __TwoItemList[0].HandleIsStateThat(
                window.Enums.EBigCalenderCellState.NotSelected
              )
            ) {
              return {
                CanSelectable: true,
                ItemList: [__TwoItemList[0]],
              };
            }
          }
        }
      }

      if (
        _CellInstance.HandleIsStateThat(
          window.Enums.EBigCalenderCellState.SelectedFromSeller
        )
      ) {
        var __BeforeResult = false;
        var __Before = this.HandleGetCellBefore(_CellInstance);
        var __Before2 = null;
        if (
          __Before != null &&
          __Before.HandleIsStateThat(
            window.Enums.EBigCalenderCellState.SelectedFromSeller
          )
        ) {
          __Before2 = this.HandleGetCellBefore(__Before);
          if (
            __Before2 != null &&
            __Before2.HandleIsStateThat(
              window.Enums.EBigCalenderCellState.SelectedFromSeller
            )
          ) {
            __BeforeResult = true;
          }
        }

        var __LaterResult = false;
        var __Later = this.HandleGetCellLater(_CellInstance);
        var __Later2 = null;
        if (
          __Later != null &&
          __Later.HandleIsStateThat(
            window.Enums.EBigCalenderCellState.SelectedFromSeller
          )
        ) {
          __Later2 = this.HandleGetCellLater(__Later);
          if (
            __Later2 != null &&
            __Later2.HandleIsStateThat(
              window.Enums.EBigCalenderCellState.SelectedFromSeller
            )
          ) {
            __LaterResult = true;
          }
        }

        if (__LaterResult && __BeforeResult) {
          return {
            CanSelectable: true,
            ItemList: [],
          };
        }

        if (
          __Before != null &&
          __LaterResult &&
          __Before.HandleIsStateThat(
            window.Enums.EBigCalenderCellState.NotSelected
          )
        ) {
          return {
            CanSelectable: true,
            ItemList: [],
          };
        }

        if (
          __Before == null &&
          __Later != null &&
          __Later.HandleIsStateThat(
            window.Enums.EBigCalenderCellState.SelectedFromSeller
          ) &&
          __Later2 != null &&
          !__Later2.HandleIsStateThat(
            window.Enums.EBigCalenderCellState.SelectedFromSeller
          )
        ) {
          return {
            CanSelectable: true,
            ItemList: [__Later],
          };
        }

        if (
          __Later != null &&
          __BeforeResult &&
          __Later.HandleIsStateThat(
            window.Enums.EBigCalenderCellState.NotSelected
          )
        ) {
          return {
            CanSelectable: true,
            ItemList: [],
          };
        }

        if (
          __Later == null &&
          __Before != null &&
          __Before.HandleIsStateThat(
            window.Enums.EBigCalenderCellState.SelectedFromSeller
          ) &&
          __Before2 != null &&
          !__Before2.HandleIsStateThat(
            window.Enums.EBigCalenderCellState.SelectedFromSeller
          )
        ) {
          return {
            CanSelectable: true,
            ItemList: [__Before],
          };
        }

        var __TempList = [];
        if (
          __Before2 == null ||
          !__Before2.HandleIsStateThat(
            window.Enums.EBigCalenderCellState.SelectedFromSeller
          )
        ) {
          if (
            __Before != null &&
            __Before.HandleIsStateThat(
              window.Enums.EBigCalenderCellState.SelectedFromSeller
            )
          ) {
            __TempList.push(__Before);
          }
        }

        if (
          __Later2 == null ||
          !__Later2.HandleIsStateThat(
            window.Enums.EBigCalenderCellState.SelectedFromSeller
          )
        ) {
          if (
            __Later != null &&
            __Later.HandleIsStateThat(
              window.Enums.EBigCalenderCellState.SelectedFromSeller
            )
          ) {
            __TempList.push(__Later);
          }
        }

        if (__TempList.length > 0) {
          return {
            CanSelectable: true,
            ItemList: __TempList,
          };
        }

        if (!__BeforeResult && !__LaterResult) {
          return false;
        }

        if (
          __Before != null &&
          __Before.HandleIsStateThat(
            window.Enums.EBigCalenderCellState.SelectedFromSeller
          ) &&
          !__BeforeResult
        ) {
          return {
            CanSelectable: true,
            ItemList: [__Before],
          };
        }

        if (
          __Later != null &&
          __Later.HandleIsStateThat(
            window.Enums.EBigCalenderCellState.SelectedFromSeller
          ) &&
          !__LaterResult
        ) {
          return {
            CanSelectable: true,
            ItemList: [__Later],
          };
        }

        if (
          (!__BeforeResult &&
            __Before != null &&
            !__Before.HandleIsStateThat(
              window.Enums.EBigCalenderCellState.SelectedFromSeller
            )) ||
          (!__LaterResult &&
            __Later != null &&
            !__Later.HandleIsStateThat(
              window.Enums.EBigCalenderCellState.SelectedFromSeller
            ))
        ) {
          return {
            CanSelectable: true,
            ItemList: [],
          };
        }

        if (
          __Later == null &&
          __Before != null &&
          __Before.HandleIsStateThat(
            window.Enums.EBigCalenderCellState.SelectedFromSeller
          )
        ) {
          __Before2 = this.HandleGetCellBefore(__Before);
          if (
            __Before2 != null &&
            __Before2.HandleIsStateThat(
              window.Enums.EBigCalenderCellState.SelectedFromSeller
            )
          ) {
            return {
              CanSelectable: true,
              ItemList: [],
            };
          }
        }

        if (
          __Before == null &&
          __Later != null &&
          __Later.HandleIsStateThat(
            window.Enums.EBigCalenderCellState.SelectedFromSeller
          )
        ) {
          __Later2 = this.HandleGetCellLater(__Later);
          if (
            __Later2 != null &&
            __Later2.HandleIsStateThat(
              window.Enums.EBigCalenderCellState.SelectedFromSeller
            )
          ) {
            return {
              CanSelectable: true,
              ItemList: [],
            };
          }
        }
      }

      return {
        CanSelectable: false,
        ItemList: [],
      };
    },
    HandleGetCellCanSelectable: function (_CellInstance) {
      var __Index = this.HandleGetCellIndex(_CellInstance);

      if (
        this.props.type == window.Enums.EBigCalenderType.AvailableTimeSelection
      ) {
        return this.HandleGetCellCanSelectable_AvailableTimeSelection(
          _CellInstance,
          __Index
        );
      } else if (
        this.props.type == window.Enums.EBigCalenderType.ClassTimeSelection
      ) {
        return this.HandleGetCellCanSelectable_ClassTimeSelection(
          _CellInstance,
          __Index
        );
      } else if (
        this.props.type ==
        window.Enums.EBigCalenderType.CustomerAvailableBookSelection_Individual
      ) {
        return this.HandleGetCellCanSelectable_CustomerAvailableBookSelection(
          window.Enums.EBigCalenderCellState
            .SelectableIndividualCellFromCustomer,
          _CellInstance,
          __Index
        );
      } else if (
        this.props.type ==
        window.Enums.EBigCalenderType.CustomerAvailableBookSelection_Class
      ) {
        return this.HandleGetCellCanSelectable_CustomerAvailableBookSelection(
          window.Enums.EBigCalenderCellState.SelectableGroupCellFromCustomer,
          _CellInstance,
          __Index
        );
      } else {
        return true;
      }
    },

    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    HandleGetCellIndex: function (_CellInstance) {
      for (var i = 0; i < this.ItemList.length; i++) {
        if (this.ItemList[i].ReactItem.key == _CellInstance.props.mykey) {
          return i;
        }
      }
      return -1;
    },
    componentWillMount: function () {
      TBigCalender.BaseObject.componentWillMount.call(this);
      GenericWebGraph.AddResizeEvent(this.HandleOnResizeMain);
    },
    componentWillUnmount: function () {
      TBigCalender.BaseObject.componentWillUnmount.call(this);
      GenericWebGraph.RemoveResizeEvent(this.HandleOnResizeMain);
    },
    HandleCurrentGetDateString: function () {
      var __WeekStartDate = this.HandleGetStartDate();
      var __Date = new Date(__WeekStartDate);
      var __NextDate = new Date(__WeekStartDate);

      __Date.setDate(__WeekStartDate.getDate() + this.state.addWeek * 7);
      __NextDate.setDate(
        __WeekStartDate.getDate() + (this.state.addWeek + 1) * 7
      );

      var __Result = moment(__Date)
        .locale(this.state.Language.LanguageCode)
        .format("DD MMMM");
      __Result +=
        " - " +
        moment(__NextDate)
          .locale(this.state.Language.LanguageCode)
          .format("DD MMMM");

      return __Result;
    },
    HandleCreateBigCalenderItem: function (
      _Key,
      _Right,
      _Bottom,
      _Date,
      _BlockStartHour,
      _BlockStartMinute,
      _BlockEndHour,
      _BlockEndMinute,
      _CellState,
      _MergedCell,
      _StepMinute
    ) {
      var __Temp = React.createRef();
      return (
        <TBigCalenderItem
          ref={_Key}
          key={_Key}
          mykey={_Key}
          locked={this.props.locked}
          cellstate={_CellState}
          owner={this}
          right={_Right}
          bottom={_Bottom}
          daydate={_Date}
          blockstarthour={_BlockStartHour}
          blockendhour={_BlockEndHour}
          blockstartminute={_BlockStartMinute}
          blockendminute={_BlockEndMinute}
          stepminute={_StepMinute}
          mergedcell={_MergedCell}
          type={this.props.type}
        />
      );
    },
    HandleGetBigCalenderItem: function (
      _Key,
      _Right,
      _Bottom,
      _Date,
      _BlockStartHour,
      _BlockStartMinute,
      _BlockEndHour,
      _BlockEndMinute,
      _CellState,
      _ForceCellState,
      _MergedCell,
      _StepMinute
    ) {
      var __ResultItem = this.ItemList.find(function (_Item) {
        return _Item.ReactItem.key == _Key;
      });

      if (
        __ResultItem != null &&
        __ResultItem.Instance &&
        __ResultItem.Instance != null
      ) {
        var __Right = __ResultItem.Instance.props.right;
        var __Bottom = __ResultItem.Instance.props.bottom;
        var __Date = __ResultItem.Instance.props.daydate;
        var __BlockStartHour = __ResultItem.Instance.props.blockstarthour;
        var __BlockStartMinute = __ResultItem.Instance.props.blockstartminute;
        var __BlockEndHour = __ResultItem.Instance.props.blockendhour;
        var __BlockEndMinute = __ResultItem.Instance.props.blockendminute;
        var __CellState = __ResultItem.Instance.state.cellstate;

        if (_ForceCellState) {
          __CellState = _CellState;
        }

        __ResultItem.ReactItem = this.HandleCreateBigCalenderItem(
          __ResultItem.ReactItem.key,
          __Right,
          __Bottom,
          __Date,
          __BlockStartHour,
          __BlockStartMinute,
          __BlockEndHour,
          __BlockEndMinute,
          __CellState,
          _MergedCell,
          _StepMinute
        );
        __ResultItem.Instance.setState({
          cellstate: __CellState,
        });

        return __ResultItem.ReactItem;
      } else {
        __ResultItem = this.HandleCreateBigCalenderItem(
          _Key,
          _Right,
          _Bottom,
          _Date,
          _BlockStartHour,
          _BlockStartMinute,
          _BlockEndHour,
          _BlockEndMinute,
          _CellState,
          _MergedCell,
          _StepMinute
        );
        this.ItemList.push({ ReactItem: __ResultItem });
        return __ResultItem;
      }
    },
    HandleGetCalenderHeaderDates: function () {
      var __This = this;
      const { classes } = this.props;

      var __WeekStartDate = this.HandleGetStartDate();

      var __StartHour = this.props.starthour;
      var __EndHour = this.props.endhour;

      var __StepMinute = this.props.stepminute;

      var __StartMinute = this.props.startminute;
      var __EndMinute = this.props.endminute;

      var __Array = new Array();
      for (var i = 0; i < 8; i++) {
        __Array.push(i);
      }

      return __Array.map((__Item, __Index) => {
        if (__Item % 8 == 0) {
          return (
            <TBigCalenderDayHeader
              key={"CalendeDayHeader_" + __Index.toString()}
              daydate={__Date}
              {...__This.props}
              first={true}
              mobileSize={__This.state.mobileSize}
            />
          );
        } else {
          var __Date = new Date(__WeekStartDate);
          __Date.setDate(
            __WeekStartDate.getDate() +
              ((__Item % 8) - 1) +
              __This.state.addWeek * 7
          );
          return (
            <TBigCalenderDayHeader
              key={"CalendeDayHeader_" + __Index.toString()}
              daydate={__Date}
              {...__This.props}
              mobileSize={__This.state.mobileSize}
            />
          );
        }
      });
    },
    HandleGetCalender: function () {
      var __This = this;
      const { classes } = this.props;

      var __WeekStartDate = this.HandleGetStartDate();

      var __StartHour = this.props.starthour;
      var __EndHour = this.props.endhour;

      var __StepMinute = this.props.stepminute;
      var __MergedCell = this.props.mergedcell;

      var __StartMinute = this.props.startminute;
      var __EndMinute = this.props.endminute;

      //var __TotalHour = (__EndHour - __StartHour);
      //var __Count = (Math.floor(((__TotalHour * 60) + (__EndMinute - __StartMinute)) / __StepMinute) + 1) * 8;

      var __TotalMinute =
        __EndHour * 60 + __EndMinute - (__StartHour * 60 + __StartMinute);
      var __Count = Math.floor(__TotalMinute / __StepMinute) * 8;

      var __Array = new Array();
      for (var i = 0; i < __Count; i++) {
        __Array.push(i);
      }

      return __Array.map((__Item, __Index) => {
        if (__Item % 8 == 0) {
          var __Hour =
            __StartHour +
            Math.floor(
              ((__Item / 8) * __StepMinute + __StartMinute + __StepMinute) / 60
            );
          var __Minute =
            (__StartMinute + __StepMinute + (__Item / 8) * __StepMinute) % 60;
          if (
            __Count - 8 == __Item &&
            __This.props.type !=
              window.Enums.EBigCalenderType.MiniAvailableTimeShow
          ) {
            return (
              <TBigCalenderTimeHeader
                type={__This.props.type}
                key={"CalendeTimeHeader_" + __Index.toString()}
                text={""}
                right={__Item % 8 == 7}
                bottom={__Count <= __Item + 8}
                {...__This.props}
              />
            );
          }

          if (
            __This.props.type ==
            window.Enums.EBigCalenderType.MiniAvailableTimeShow
          ) {
            return (
              <TBigCalenderTimeHeader
                type={__This.props.type}
                key={"CalendeTimeHeader_" + __Index.toString()}
                text={
                  (__Hour - __StepMinute / 60).toString().padStart(2, "0") +
                  " - " +
                  __Hour.toString().padStart(2, "0")
                }
                right={__Item % 8 == 7}
                bottom={__Count <= __Item + 8}
                {...__This.props}
              />
            );
          } else {
            return (
              <TBigCalenderTimeHeader
                type={__This.props.type}
                key={"CalendeTimeHeader_" + __Index.toString()}
                text={
                  __Hour.toString().padStart(2, "0") +
                  ":" +
                  __Minute.toString().padStart(2, "0")
                }
                right={__Item % 8 == 7}
                bottom={__Count <= __Item + 8}
                {...__This.props}
              />
            );
          }
        } else {
          var __BlockStartHour =
            __StartHour +
            Math.floor(
              (Math.floor(__Item / 8) * __StepMinute + __StartMinute) / 60
            );
          var __BlockEndHour =
            __StartHour +
            Math.floor(
              (Math.floor(__Item / 8) * __StepMinute +
                __StartMinute +
                __StepMinute) /
                60
            );
          var __BlockStartMinute =
            (__StartMinute + Math.floor(__Item / 8) * __StepMinute) % 60;
          var __BlockEndMinute =
            (__StartMinute +
              __StepMinute +
              Math.floor(__Item / 8) * __StepMinute) %
            60;
          var __Date = new Date(__WeekStartDate);
          __Date.setDate(
            __WeekStartDate.getDate() +
              ((__Item % 8) - 1) +
              __This.state.addWeek * 7
          );

          var __Key = __This.HandleGetKey(
            __Date,
            __BlockStartHour,
            __BlockStartMinute,
            __BlockEndHour,
            __BlockEndMinute
          );
          return __This.HandleGetBigCalenderItem(
            __Key,
            __Item % 8 == 7,
            __Count <= __Item + 8,
            __Date,
            __BlockStartHour,
            __BlockStartMinute,
            __BlockEndHour,
            __BlockEndMinute,
            0,
            false,
            __MergedCell,
            __StepMinute
          );
          /*return <TBigCalenderItem key={__Date.getMonth() + "_" + __Date.getDate() + "_" + __BlockStartHour + "_" + __BlockStartMinute + "_" + __BlockEndHour + "_" + __BlockEndMinute}
            right={(__Item % 8) == 7}
            bottom={__Count <= (__Item + 8)}
            daydate={__Date}
            blockstarthour={__BlockStartHour}
            blockendhour={__BlockEndHour}
            blockstartminute={__BlockStartMinute}
            blockendminute={__BlockEndMinute}
            {...__This.props} />;*/
        }
      });
    },
    //////////////////////////////////////////////////////////////////
    /////////////////  Örenek Renkler ////////////////////////////////
    //////////////////////////////////////////////////////////////////

    HandleGetSelectionSamples_ClassTimeSelectionMobile: function () {
      const { classes } = this.props;
      return (
        <Grid container>
          <Grid item xs={12} style={{ display: "flex" }}>
            <Grid item style={{}}>
              <div
                className={classNames(
                  classes.sellerSampleSelectedBlockInSeller
                )}
              ></div>
            </Grid>
            <Grid item style={{}}>
              <div style={{ fontSize: "12px" }}>
                {this.state.Language
                  .SellerAvailableTimeSelect_SampleSelectableBlock +
                  " (" +
                  this.state.Language.YourAvailableTimes +
                  ")"}{" "}
              </div>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ display: "flex" }}>
            <Grid item>
              <div
                className={classNames(classes.sellerClassBlockInLessonModal)}
              ></div>
            </Grid>
            <Grid item style={{}}>
              <div style={{ fontSize: "12px" }}>
                {
                  this.state.Language
                    .SellerAvailableTimeSelect_SampleSelectedBlock
                }
              </div>
            </Grid>
          </Grid>
        </Grid>
      );
    },

    HandleGetSelectionSamples_ClassTimeSelection: function () {
      const { classes } = this.props;
      return (
        <Grid
          container
          spacing={1}
          direction="row"
          alignItems="flex-end"
          style={{ flex: 1 }}
        >
          <Grid item style={{}}>
            <div
              className={classNames(classes.sellerSampleSelectedBlock)}
            ></div>
          </Grid>
          <Grid item style={{}}>
            <div>
              {this.state.Language
                .SellerAvailableTimeSelect_SampleSelectableBlock +
                " (" +
                this.state.Language.YourAvailableTimes +
                ")"}{" "}
            </div>
          </Grid>
          <Grid item style={{ marginLeft: "10px" }}>
            <div className={classNames(classes.sellerClassBlock)}></div>
          </Grid>
          <Grid item style={{}}>
            <div>
              {
                this.state.Language
                  .SellerAvailableTimeSelect_SampleSelectedBlock
              }
            </div>
          </Grid>
        </Grid>
      );
    },
    HandleGetSelectionSamples_CustomerAvailableBookSelection_ClassMobile:
      function () {
        const { classes } = this.props;
        return (
          <Grid
            container
            spacing={1}
            direction="row"
            alignItems="flex-end"
            style={{ flex: 1 }}
          >
            <Grid item xs={6} style={{ display: "flex" }}>
              <Grid item style={{}}>
                <div
                  className={classNames(classes.sellerSampleAvailableBlockMini)}
                ></div>
              </Grid>
              <Grid item style={{}}>
                <div style={{ fontSize: "10px", marginLeft: "5px" }}>
                  {this.state.Language.CustomerSelection_FreeBox}
                </div>
              </Grid>
            </Grid>
            <Grid item xs={6} style={{ display: "flex" }}>
              <Grid item>
                <div
                  className={classNames(
                    classes.customerSampleCanSelectClassBlockMini
                  )}
                ></div>
              </Grid>
              <Grid item style={{}}>
                <div style={{ fontSize: "10px", marginLeft: "5px" }}>
                  {this.state.Language.CustomerSelection_AvailableBox}
                </div>
              </Grid>
            </Grid>
            <Grid item xs={6} style={{ display: "flex" }}>
              <Grid item>
                <div
                  className={classNames(
                    classes.customerSampleBookedFromYouLessonClassBlockMini
                  )}
                ></div>
              </Grid>
              <Grid item style={{}}>
                <div style={{ fontSize: "10px", marginLeft: "5px" }}>
                  {this.state.Language.CustomerSelection_BookedByYouBox}
                </div>
              </Grid>
            </Grid>
            <Grid item xs={6} style={{ display: "flex" }}>
              <Grid item>
                <div
                  className={classNames(
                    classes.customerSampleFullClassBlockMini
                  )}
                ></div>
              </Grid>
              <Grid item style={{}}>
                <div style={{ fontSize: "10px", marginLeft: "5px" }}>
                  {this.state.Language.CustomerSelection_FullGroupBox}
                </div>
              </Grid>
            </Grid>
            <Grid item xs={6} style={{ display: "flex" }}>
              {!this.props.locked && (
                <Grid item>
                  <div
                    className={classNames(
                      classes.sampleSelectedBlockFromCustomerMini
                    )}
                  ></div>
                </Grid>
              )}
              {!this.props.locked && (
                <Grid item style={{}}>
                  <div style={{ fontSize: "10px", marginLeft: "5px" }}>
                    {this.state.Language.CustomerSelection_SelectedBox}
                  </div>
                </Grid>
              )}
            </Grid>
          </Grid>
        );
      },
    HandleGetSelectionSamples_CustomerAvailableBookSelection_Class:
      function () {
        const { classes } = this.props;
        return (
          <Grid
            container
            spacing={1}
            direction="row"
            alignItems="flex-end"
            style={{ flex: 1 }}
          >
            <Grid item style={{}}>
              <div
                className={classNames(classes.sellerSampleAvailableBlock)}
              ></div>
            </Grid>
            <Grid item style={{}}>
              <div>{this.state.Language.CustomerSelection_FreeBox}</div>
            </Grid>
            <Grid item style={{ marginLeft: "10px" }}>
              <div
                className={classNames(
                  classes.customerSampleCanSelectClassBlock
                )}
              ></div>
            </Grid>
            <Grid item style={{}}>
              <div>{this.state.Language.CustomerSelection_AvailableBox}</div>
            </Grid>
            <Grid item style={{ marginLeft: "10px" }}>
              <div
                className={classNames(
                  classes.customerSampleBookedFromYouLessonClassBlock
                )}
              ></div>
            </Grid>
            <Grid item style={{}}>
              <div>{this.state.Language.CustomerSelection_BookedByYouBox}</div>
            </Grid>
            <Grid item style={{ marginLeft: "10px" }}>
              <div
                className={classNames(classes.customerSampleFullClassBlock)}
              ></div>
            </Grid>
            <Grid item style={{}}>
              <div>{this.state.Language.CustomerSelection_FullGroupBox}</div>
            </Grid>
            {!this.props.locked && (
              <Grid item style={{ marginLeft: "10px" }}>
                <div
                  className={classNames(
                    classes.sampleSelectedBlockFromCustomer
                  )}
                ></div>
              </Grid>
            )}
            {!this.props.locked && (
              <Grid item style={{}}>
                <div>{this.state.Language.CustomerSelection_SelectedBox}</div>
              </Grid>
            )}
          </Grid>
        );
      },
    HandleGetSelectionSamples_CustomerAvailableBookSelection_IndividualMobile:
      function () {
        const { classes } = this.props;
        return (
          <Grid
            container
            spacing={1}
            direction="row"
            alignItems="flex-end"
            style={{ flex: 1 }}
          >
            <Grid item xs={6} style={{ display: "flex" }}>
              <Grid item style={{}}>
                <div
                  className={classNames(classes.customerSampleFreeBlockMini)}
                ></div>
              </Grid>
              <Grid item style={{}}>
                <div style={{ fontSize: "10px", marginLeft: "5px" }}>
                  {this.state.Language.CustomerSelection_FreeBox}
                </div>
              </Grid>
            </Grid>
            <Grid item xs={6} style={{ display: "flex" }}>
              <Grid item>
                <div
                  className={classNames(
                    classes.customerSampleCanSelectIndividualBlockMini
                  )}
                ></div>
              </Grid>
              <Grid item style={{}}>
                <div style={{ fontSize: "10px", marginLeft: "5px" }}>
                  {this.state.Language.CustomerSelection_AvailableBox}
                </div>
              </Grid>
            </Grid>
            <Grid item xs={6} style={{ display: "flex" }}>
              <Grid item>
                <div
                  className={classNames(
                    classes.customerSampleBookedFromYouLessonIndividualBlockMini
                  )}
                ></div>
              </Grid>
              <Grid item style={{}}>
                <div style={{ fontSize: "10px", marginLeft: "5px" }}>
                  {this.state.Language.CustomerSelection_BookedByYouBox}
                </div>
              </Grid>
            </Grid>
            <Grid item xs={6} style={{ display: "flex" }}>
              <Grid item>
                <div
                  className={classNames(
                    classes.customerSampleBookedLessonIndividualBlockMini
                  )}
                ></div>
              </Grid>
              <Grid item style={{}}>
                <div style={{ fontSize: "10px", marginLeft: "5px" }}>
                  {this.state.Language.CustomerSelection_BookedBox}
                </div>
              </Grid>
            </Grid>
            <Grid item xs={6} style={{ display: "flex" }}>
              {!this.props.locked && (
                <Grid item>
                  <div
                    className={classNames(
                      classes.sampleSelectedBlockFromCustomerMini
                    )}
                  ></div>
                </Grid>
              )}
              {!this.props.locked && (
                <Grid item style={{}}>
                  <div style={{ fontSize: "10px", marginLeft: "5px" }}>
                    {this.state.Language.CustomerSelection_SelectedBox}
                  </div>
                </Grid>
              )}
            </Grid>
          </Grid>
        );
      },
    HandleGetSelectionSamples_CustomerAvailableBookSelection_Individual:
      function () {
        const { classes } = this.props;
        return (
          <Grid
            container
            spacing={1}
            direction="row"
            alignItems="flex-end"
            style={{ flex: 1 }}
          >
            <Grid item style={{}}>
              <div
                className={classNames(classes.customerSampleFreeBlock)}
              ></div>
            </Grid>
            <Grid item style={{}}>
              <div>{this.state.Language.CustomerSelection_FreeBox}</div>
            </Grid>
            <Grid item style={{ marginLeft: "10px" }}>
              <div
                className={classNames(
                  classes.customerSampleCanSelectIndividualBlock
                )}
              ></div>
            </Grid>
            <Grid item style={{}}>
              <div>{this.state.Language.CustomerSelection_AvailableBox}</div>
            </Grid>
            <Grid item style={{ marginLeft: "10px" }}>
              <div
                className={classNames(
                  classes.customerSampleBookedFromYouLessonIndividualBlock
                )}
              ></div>
            </Grid>
            <Grid item style={{}}>
              <div>{this.state.Language.CustomerSelection_BookedByYouBox}</div>
            </Grid>
            <Grid item style={{ marginLeft: "10px" }}>
              <div
                className={classNames(
                  classes.customerSampleBookedLessonIndividualBlock
                )}
              ></div>
            </Grid>
            <Grid item style={{}}>
              <div>{this.state.Language.CustomerSelection_BookedBox}</div>
            </Grid>
            {!this.props.locked && (
              <Grid item style={{ marginLeft: "10px" }}>
                <div
                  className={classNames(
                    classes.sampleSelectedBlockFromCustomer
                  )}
                ></div>
              </Grid>
            )}
            {!this.props.locked && (
              <Grid item style={{}}>
                <div>{this.state.Language.CustomerSelection_SelectedBox}</div>
              </Grid>
            )}
          </Grid>
        );
      },
    HandleGetSelectionSamples_AvailableTimeSelectionMobile: function () {
      const { classes } = this.props;
      return (
        <Grid container>
          <Grid item xs={6} style={{ display: "flex" }}>
            <Grid item style={{}}>
              <div
                className={classNames(
                  classes.sellerSampleAvailableBlockInSeller
                )}
              ></div>
            </Grid>
            <Grid item style={{}}>
              <div style={{ fontSize: "12px" }}>
                {
                  this.state.Language
                    .SellerAvailableTimeSelect_SampleSelectableBlock
                }
              </div>
            </Grid>
          </Grid>
          <Grid item xs={6} style={{ display: "flex" }}>
            <Grid item>
              <div
                className={classNames(
                  classes.sellerSampleSelectedBlockInSeller
                )}
              ></div>
            </Grid>
            <Grid item style={{}}>
              <div style={{ fontSize: "12px" }}>
                {
                  this.state.Language
                    .SellerAvailableTimeSelect_SampleSelectedBlock
                }
              </div>
            </Grid>
          </Grid>
        </Grid>
      );
    },
    HandleGetSelectionSamples_AvailableTimeSelection: function () {
      const { classes } = this.props;
      return (
        <Grid
          container
          spacing={1}
          direction="row"
          alignItems="flex-end"
          style={{ flex: 1 }}
        >
          <Grid item style={{}}>
            <div
              className={classNames(classes.sellerSampleAvailableBlock)}
            ></div>
          </Grid>
          <Grid item style={{}}>
            <div>
              {
                this.state.Language
                  .SellerAvailableTimeSelect_SampleSelectableBlock
              }
            </div>
          </Grid>
          <Grid item style={{ marginLeft: "10px" }}>
            <div
              className={classNames(classes.sellerSampleSelectedBlock)}
            ></div>
          </Grid>
          <Grid item style={{}}>
            <div>
              {
                this.state.Language
                  .SellerAvailableTimeSelect_SampleSelectedBlock
              }
            </div>
          </Grid>

          <Grid item style={{ marginLeft: "10px" }}>
            <div
              className={classNames(
                classes.customerSampleBookedFromYouLessonClassBlock
              )}
            ></div>
          </Grid>
          <Grid item style={{}}>
            <div>{this.state.Language.ClassLessonTimeBlock}</div>
          </Grid>

          <Grid item style={{ marginLeft: "10px" }}>
            <div
              className={classNames(
                classes.customerSampleBookedLessonIndividualBlock
              )}
            ></div>
          </Grid>
          <Grid item style={{}}>
            <div>{this.state.Language.Reservation}</div>
          </Grid>
        </Grid>
      );
    },
    HandleGetSelectionSamples_SellerBookedSchedulerMobile: function () {
      const { classes } = this.props;
      return (
        <Grid
          container
          spacing={1}
          direction="row"
          alignItems="flex-end"
          style={{ flex: 1 }}
        >
          <Grid item style={{}}>
            <div
              className={classNames(classes.sellerSampleSelectedBlockMini)}
            ></div>
          </Grid>
          <Grid item style={{}}>
            <div style={{ fontSize: "12px" }}>
              {this.state.Language.IndividualLesson}
            </div>
          </Grid>
          <Grid item style={{ marginLeft: "10px" }}>
            <div
              className={classNames(
                classes.customerSampleCanSelectClassBlockMini
              )}
            ></div>
          </Grid>
          <Grid item style={{}}>
            <div style={{ fontSize: "12px" }}>
              {this.state.Language.CollectiveLesson}
            </div>
          </Grid>
        </Grid>
      );
    },
    HandleGetSelectionSamples_SellerBookedScheduler: function () {
      const { classes } = this.props;
      return (
        <Grid
          container
          spacing={1}
          direction="row"
          alignItems="flex-end"
          style={{ flex: 1 }}
        >
          <Grid item style={{}}>
            <div
              className={classNames(classes.sellerSampleSelectedBlock)}
            ></div>
          </Grid>
          <Grid item style={{}}>
            <div>{this.state.Language.IndividualLesson}</div>
          </Grid>
          <Grid item style={{ marginLeft: "10px" }}>
            <div
              className={classNames(classes.customerSampleCanSelectClassBlock)}
            ></div>
          </Grid>
          <Grid item style={{}}>
            <div>{this.state.Language.CollectiveLesson}</div>
          </Grid>
        </Grid>
      );
    },
    HandleGetSelectionSamples_CustomerBookedSchedulerMobile: function () {
      const { classes } = this.props;
      return (
        <Grid
          container
          spacing={1}
          direction="row"
          alignItems="flex-end"
          style={{ flex: 1 }}
        >
          <Grid item style={{}}>
            <div
              className={classNames(classes.sellerSampleSelectedBlockMini)}
            />
          </Grid>
          <Grid item style={{}}>
            <div style={{ fontSize: "12px" }}>
              {this.state.Language.IndividualLesson}
            </div>
          </Grid>
          <Grid item style={{ marginLeft: "10px" }}>
            <div
              className={classNames(
                classes.customerSampleCanSelectClassBlockMini
              )}
            />
          </Grid>
          <Grid item style={{}}>
            <div style={{ fontSize: "12px" }}>
              {this.state.Language.CollectiveLesson}
            </div>
          </Grid>
        </Grid>
      );
    },

    HandleGetSelectionSamples_CustomerBookedScheduler: function () {
      const { classes } = this.props;
      return (
        <Grid
          container
          spacing={1}
          direction="row"
          alignItems="flex-end"
          style={{ flex: 1 }}
        >
          <Grid item style={{}}>
            <div
              className={classNames(classes.sellerSampleSelectedBlock)}
            ></div>
          </Grid>
          <Grid item style={{}}>
            <div>{this.state.Language.IndividualLesson}</div>
          </Grid>
          <Grid item style={{ marginLeft: "10px" }}>
            <div
              className={classNames(classes.customerSampleCanSelectClassBlock)}
            ></div>
          </Grid>
          <Grid item style={{}}>
            <div>{this.state.Language.CollectiveLesson}</div>
          </Grid>
        </Grid>
      );
    },
    HandleGetSelectionSamples: function () {
      const { classes } = this.props;

      if (this.props.type == window.Enums.EBigCalenderType.ClassTimeSelection) {
        if (this.state.mobileSize) {
          return this.HandleGetSelectionSamples_ClassTimeSelectionMobile();
        } else {
          return this.HandleGetSelectionSamples_ClassTimeSelection();
        }
      } else if (
        this.props.type ==
        window.Enums.EBigCalenderType.CustomerAvailableBookSelection_Class
      ) {
        if (this.state.mobileSize) {
          return this.HandleGetSelectionSamples_CustomerAvailableBookSelection_ClassMobile();
        } else {
          return this.HandleGetSelectionSamples_CustomerAvailableBookSelection_Class();
        }
      } else if (
        this.props.type ==
        window.Enums.EBigCalenderType.CustomerAvailableBookSelection_Individual
      ) {
        if (this.state.mobileSize) {
          return this.HandleGetSelectionSamples_CustomerAvailableBookSelection_IndividualMobile();
        } else {
          return this.HandleGetSelectionSamples_CustomerAvailableBookSelection_Individual();
        }
      } else if (
        this.props.type == window.Enums.EBigCalenderType.AvailableTimeSelection
      ) {
        if (this.state.mobileSize) {
          return this.HandleGetSelectionSamples_AvailableTimeSelectionMobile();
        } else {
          return this.HandleGetSelectionSamples_AvailableTimeSelection();
        }
      } else if (
        this.props.type == window.Enums.EBigCalenderType.SellerBookedScheduler
      ) {
        if (this.state.mobileSize) {
          return this.HandleGetSelectionSamples_SellerBookedSchedulerMobile();
        } else {
          return this.HandleGetSelectionSamples_SellerBookedScheduler();
        }
      } else if (
        this.props.type == window.Enums.EBigCalenderType.CustomerBookedScheduler
      ) {
        if (this.state.mobileSize) {
          return this.HandleGetSelectionSamples_CustomerBookedSchedulerMobile();
        } else {
          return this.HandleGetSelectionSamples_CustomerBookedScheduler();
        }
      } else if (
        this.props.type == window.Enums.EBigCalenderType.MiniAvailableTimeShow
      ) {
        return null;
      } else {
        return (
          <Grid
            container
            spacing={1}
            direction="row"
            alignItems="flex-end"
            style={{ flex: 1 }}
          >
            <Grid item style={{}}>
              <div
                className={classNames(classes.sellerSampleAvailableBlock)}
              ></div>
            </Grid>
            <Grid item style={{}}>
              <div>
                {
                  this.state.Language
                    .SellerAvailableTimeSelect_SampleSelectableBlock
                }
              </div>
            </Grid>
            <Grid item style={{ marginLeft: "10px" }}>
              <div
                className={classNames(classes.sellerSampleSelectedBlock)}
              ></div>
            </Grid>
            <Grid item style={{}}>
              <div>
                {
                  this.state.Language
                    .SellerAvailableTimeSelect_SampleSelectedBlock
                }
              </div>
            </Grid>
          </Grid>
        );
      }
    },

    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    HandleGetCardHeaderStyle: function () {
      if (this.props.wrapmodal) {
        return {};
      } else if (
        this.props.type == window.Enums.EBigCalenderType.MiniAvailableTimeShow
      ) {
        return { paddingTop: "0px", paddingBottom: "0px" };
      } else if (
        this.props.type == window.Enums.EBigCalenderType.AvailableTimeSelection
      ) {
        return { paddingTop: "0px", paddingBottom: "0px" };
      } else {
        return { paddingTop: "0px" };
      }
    },
    HandleGetCardHeaderTitleGridStyle: function () {
      var __This = this;
      if (
        this.props.type == window.Enums.EBigCalenderType.MiniAvailableTimeShow
      ) {
        return { flex: 1 };
      } else {
        if (
          this.props.type ===
            window.Enums.EBigCalenderType.SellerBookedScheduler &&
          this.state.mobileSize
        ) {
          return {
            flex: 1,
            marginTop: "10px",
            marginBottom: "10px",
            margin: "-10px",
          };
        } else if (
          this.props.type ===
            window.Enums.EBigCalenderType.CustomerBookedScheduler &&
          this.state.mobileSize
        ) {
          return {
            flex: 1,
            marginTop: "10px",
            marginBottom: "10px",
            margin: "-10px",
          };
        } else if (
          (__This.props.type ===
            window.Enums.EBigCalenderType
              .CustomerAvailableBookSelection_Individual ||
            __This.props.type ===
              window.Enums.EBigCalenderType
                .CustomerAvailableBookSelection_Class) &&
          __This.state.mobileSize
        ) {
          return {
            flex: 1,
            marginBlockEnd: "-30px",
            marginBlockStart: "-15px",
          };
        } else {
          return {
            flex: 1,
            marginTop: "10px",
            marginBottom: "10px",
            margin: "0px",
          };
        }
      }
    },
    HandleGetCalendarContainerStyle: function () {
      if (
        this.props.type == window.Enums.EBigCalenderType.MiniAvailableTimeShow
      ) {
        return {
          flex: 1,
          display: this.state.loaded ? "inherit" : "none",
          margin: "0px",
        };
      } else {
        return {
          flex: 1,
          marginTop: "10px",
          marginBottom: "20px",
          display: this.state.loaded ? "inherit" : "none",
          margin: "0px",
        };
      }
    },
    HandleGetMainContainerClass: function () {
      const { classes } = this.props;
      if (
        this.props.type == window.Enums.EBigCalenderType.MiniAvailableTimeShow
      ) {
        return classes.miniCardContent;
      } else {
        return classes.cardContent;
      }
    },
    HandleGetMainContainerStyle: function () {
      if (
        this.props.type == window.Enums.EBigCalenderType.MiniAvailableTimeShow
      ) {
        return {};
      } else if (
        this.props.type == window.Enums.EBigCalenderType.SellerBookedScheduler
      ) {
        return { height: "1200px" };
      } else if (
        this.props.type == window.Enums.EBigCalenderType.CustomerBookedScheduler
      ) {
        return { height: "1200px" };
      } else {
        return { height: this.state.contentHeight.toString() + "px" };
      }
    },
    HandleWrapCardItem: function (_Item) {
      var __This = this;
      if (
        this.props.type == window.Enums.EBigCalenderType.MiniAvailableTimeShow
      ) {
        return (
          <CardActions
            onClick={this.props.onClick}
            style={{
              paddingLeft: "0px",
              paddingRight: "0px",
              display:
                __This.props.onProfile !== undefined &&
                __This.props.onProfile &&
                "block",
            }}
          >
            {_Item}
          </CardActions>
        );
      } else {
        return _Item;
      }
    },
    HandleGetDateString: function () {
      var __This = this;
      if (
        __This.props.type ===
          window.Enums.EBigCalenderType.SellerBookedScheduler &&
        __This.state.mobileSize
      ) {
        return (
          <Typography style={{ fontSize: "12px", fontWeight: 500 }}>
            {__This.HandleCurrentGetDateString()}
          </Typography>
        );
      } else if (
        __This.props.type ===
          window.Enums.EBigCalenderType.CustomerBookedScheduler &&
        __This.state.mobileSize
      ) {
        return (
          <Typography style={{ fontSize: "12px", fontWeight: 500 }}>
            {__This.HandleCurrentGetDateString()}
          </Typography>
        );
      } else if (
        (__This.props.type ===
          window.Enums.EBigCalenderType
            .CustomerAvailableBookSelection_Individual ||
          __This.props.type ===
            window.Enums.EBigCalenderType
              .CustomerAvailableBookSelection_Class) &&
        __This.state.mobileSize
      ) {
        return (
          <Typography style={{ fontSize: "10px", fontWeight: 500 }}>
            {__This.HandleCurrentGetDateString()}
          </Typography>
        );
      } else {
        return (
          <Typography style={{ fontSize: "24px", fontWeight: 500 }}>
            {__This.HandleCurrentGetDateString()}
          </Typography>
        );
      }
    },
    HandleGetReservationCounter: function () {
      var __This = this;
      if (__This.state.mobileSize) {
        return (
          <Typography style={{ fontSize: "10px" }}>
            {__This.state.ReservationCount}
          </Typography>
        );
      } else {
        return this.state.ReservationCount;
      }
    },
    HandleGetCalendarBackIcon: function () {
      var __This = this;
      if (
        __This.props.type ===
          window.Enums.EBigCalenderType.SellerBookedScheduler &&
        __This.state.mobileSize
      ) {
        return <ArrowBackIos style={{ fontSize: "12px" }} />;
      } else if (
        __This.props.type ===
          window.Enums.EBigCalenderType.CustomerBookedScheduler &&
        __This.state.mobileSize
      ) {
        return <ArrowBackIos style={{ fontSize: "12px" }} />;
      } else if (
        (__This.props.type ===
          window.Enums.EBigCalenderType
            .CustomerAvailableBookSelection_Individual ||
          __This.props.type ===
            window.Enums.EBigCalenderType
              .CustomerAvailableBookSelection_Class) &&
        __This.state.mobileSize
      ) {
        return <ArrowBackIos style={{ fontSize: "12px" }} />;
      } else {
        return <ArrowBackIos />;
      }
    },
    HandleGetCalendarForwardIcon: function () {
      var __This = this;
      if (
        __This.props.type ===
          window.Enums.EBigCalenderType.SellerBookedScheduler &&
        __This.state.mobileSize
      ) {
        return <ArrowForwardIos style={{ fontSize: "12px" }} />;
      } else if (
        __This.props.type ===
          window.Enums.EBigCalenderType.CustomerBookedScheduler &&
        __This.state.mobileSize
      ) {
        return <ArrowForwardIos style={{ fontSize: "12px" }} />;
      } else if (
        (__This.props.type ===
          window.Enums.EBigCalenderType
            .CustomerAvailableBookSelection_Individual ||
          __This.props.type ===
            window.Enums.EBigCalenderType
              .CustomerAvailableBookSelection_Class) &&
        __This.state.mobileSize
      ) {
        return <ArrowForwardIos style={{ fontSize: "12px" }} />;
      } else {
        return <ArrowForwardIos />;
      }
    },
    HandleGetCalendarLabel: function () {
      var __This = this;
      const { classes } = this.props;
      if (__This.state.mobileSize) {
        return (
          <Grid item style={{ flex: 1 }}>
            {this.props.label ? (
              <Typography style={{ fontSize: "13px" }}>
                {this.props.label}
              </Typography>
            ) : (
              "label özelliği belirtilmedi!"
            )}
          </Grid>
        );
      } else {
        return (
          <Grid
            item
            style={{
              flex: 1,
              paddingBottom:
                __This.props.type ==
                  window.Enums.EBigCalenderType.AvailableTimeSelection ||
                __This.props.type ==
                  window.Enums.EBigCalenderType.ClassTimeSelection
                  ? "0px"
                  : "19px",
            }}
          >
            {this.props.label
              ? this.props.label
              : "label özelliği belirtilmedi!"}
          </Grid>
        );
      }
    },
    HandleGetCalendarNote: function () {
      var __This = this;
      const { classes } = this.props;
      if (
        __This.props.type ===
        window.Enums.EBigCalenderType.SellerBookedScheduler
      ) {
        return (
          <Typography className={classes.calendarNote}>
            {__This.state.Language.CalendarNote}
          </Typography>
        );
      } else if (
        __This.props.type ===
        window.Enums.EBigCalenderType.CustomerBookedScheduler
      ) {
        return (
          <Typography className={classes.calendarNote}>
            {__This.state.Language.CalendarNote}
          </Typography>
        );
      }
      return null;
    },
    /* componentDidUpdate(nextProps) {
       if (nextProps.mobileSize !== undefined && nextProps.mobileSize !== this.state.mobileSize) {
         this.setState({mobileSize: nextProps.mobileSize});
       }
     },*/
    render: function () {
      var __This = this;
      const { classes } = this.props;
      return (
        <div className="animated fadeIn">
          {this.HandleWrapCardItem(
            <Card className={classes.cardContainer} style={{}} elevation={0}>
              <CardHeader
                style={this.HandleGetCardHeaderStyle()}
                title={
                  <Grid
                    container
                    spacing={1}
                    direction="row"
                    alignItems="flex-end"
                    style={this.HandleGetCardHeaderTitleGridStyle()}
                  >
                    {this.props.type !=
                      window.Enums.EBigCalenderType.AvailableTimeSelection &&
                      this.props.type !=
                        window.Enums.EBigCalenderType.ClassTimeSelection &&
                      this.props.type !=
                        window.Enums.EBigCalenderType.MiniAvailableTimeShow && (
                        <Grid item>
                          <CardActions disableSpacing>
                            <Tooltip title={this.state.Language.PreviousWeek}>
                              <IconButton
                                onClick={() => {
                                  this.HandleLoadWeek(false);
                                  /*var __CurrentWeek = __This.state.addWeek > 0 ? __This.state.addWeek - 1 : 0;

                            __This.setState({
                                addWeek: __CurrentWeek
                            },() =>
                              {
                                __This.HandleLoadWeek();
                            });*/
                                }}
                              >
                                {__This.HandleGetCalendarBackIcon()}
                              </IconButton>
                            </Tooltip>
                            <Tooltip title={this.state.Language.NextWeek}>
                              <IconButton
                                onClick={() => {
                                  this.HandleLoadWeek(true);
                                  /*var __CurrentWeek = __This.state.addWeek + 1;
                            __This.setState({
                              addWeek: __CurrentWeek
                            }, () =>
                            {
                                __This.HandleLoadWeek();
                            });*/
                                }}
                              >
                                {__This.HandleGetCalendarForwardIcon()}
                              </IconButton>
                            </Tooltip>
                          </CardActions>
                        </Grid>
                      )}
                    {this.props.type !=
                      window.Enums.EBigCalenderType.AvailableTimeSelection &&
                      this.props.type !=
                        window.Enums.EBigCalenderType.ClassTimeSelection &&
                      this.props.type !=
                        window.Enums.EBigCalenderType.MiniAvailableTimeShow && (
                        <Grid item style={{ flex: 1, margin: "auto" }}>
                          {__This.HandleGetDateString()}
                        </Grid>
                      )}
                    {(this.props.type ==
                      window.Enums.EBigCalenderType.AvailableTimeSelection ||
                      this.props.type ==
                        window.Enums.EBigCalenderType.ClassTimeSelection) &&
                      this.HandleGetCalendarLabel()}

                    {((this.props.reservationcountvisible &&
                      this.props.type ==
                        window.Enums.EBigCalenderType
                          .CustomerAvailableBookSelection_Individual) ||
                      this.props.type ==
                        window.Enums.EBigCalenderType
                          .CustomerAvailableBookSelection_Class) && (
                      <Grid
                        item
                        style={{
                          flex: 1,
                          paddingBottom: "19px",
                          paddingRight: "20px",
                          textAlign: "right",
                        }}
                      >
                        {this.HandleGetReservationCounter()}
                      </Grid>
                    )}

                    {this.props.wrapmodal && (
                      <Grid item>
                        <CardActions disableSpacing style={{}}>
                          <IconButton
                            onClick={() => {
                              this.props.owner.HandleClose();
                            }}
                          >
                            <Close fontSize={"medium"} />
                          </IconButton>
                        </CardActions>
                      </Grid>
                    )}

                    {this.props.headerrightactions &&
                      this.props.headerrightactions}
                  </Grid>
                }
                subheader={
                  <div>
                    {this.props.type !=
                    window.Enums.EBigCalenderType.MiniAvailableTimeShow ? (
                      <Grid
                        container
                        spacing={1}
                        direction="row"
                        alignItems="flex-end"
                        style={{
                          flex: 1,
                          marginTop: "10px",
                          marginBottom: "10px" /*, paddingRight: "15px"*/,
                        }}
                      >
                        <Grid item style={{ flex: 1 }}>
                          <div className={classNames(classes.container)}>
                            {this.HandleGetCalenderHeaderDates()}
                          </div>
                        </Grid>
                      </Grid>
                    ) : (
                      <Grid
                        container
                        spacing={1}
                        direction="row"
                        alignItems="flex-end"
                        style={{ flex: 1 }}
                      >
                        <Grid item style={{ flex: 1 }}>
                          <div className={classNames(classes.miniContainer)}>
                            {this.HandleGetCalenderHeaderDates()}
                          </div>
                        </Grid>
                      </Grid>
                    )}
                    {__This.HandleGetSelectionSamples()}
                  </div>
                }
              />
              <CardContent
                ref={this.containerRef}
                className={this.HandleGetMainContainerClass()}
                style={this.HandleGetMainContainerStyle()}
              >
                <Grid
                  container
                  direction="row"
                  alignItems="flex-end"
                  style={this.HandleGetCalendarContainerStyle()}
                >
                  {this.HandleGetCalendarNote() != null && (
                    <Grid item style={{ flex: 1 }}>
                      {this.HandleGetCalendarNote()}
                    </Grid>
                  )}
                  <Grid item style={{ flex: 1 }}>
                    <div className={classNames(classes.timeGrdiContainer)}>
                      {this.HandleGetCalender(this.state.addWeek)}
                    </div>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={1}
                  direction="row"
                  alignItems="flex-end"
                  style={{
                    flex: 1,
                    marginTop: "10px",
                    marginBottom: "20px",
                    display: this.state.loaded ? "none" : "inherit",
                  }}
                >
                  <Grid item style={{ flex: 1 }}>
                    <div style={{ textAlign: "center", flex: 1 }}>
                      <CircularProgress />
                    </div>
                  </Grid>
                </Grid>
              </CardContent>
              {/*this.props.wrapmodal && <DialogActions>
                <Button onClick={() => alert("aa")} color="primary">
                  {this.state.Language.Update}
                </Button>
                <Button onClick={() => alert("aa")} color="primary">
                  {this.state.Language.Cancel}
                </Button>
              </DialogActions>*/}

              {JSTypeOperator.IsDefined(this.props.dialogActions) &&
                this.props.dialogActions}
            </Card>
          )}
        </div>
      );
    },
  },
  {}
);

export default withStyles(BigCalendarStyles)(TBigCalender);
